<template>
  <v-sheet height="100%">
    <Slide2 />
    <v-dialog v-model="modalBoolean" width="85%">
      <v-card>
        <v-toolbar dark color="primary" :fixed="true">
          <v-spacer></v-spacer>
          <v-btn icon dark @click="modalBoolean = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-row class="mb-6">
            <v-col
              cols="10"
              class="text-center"
              v-if="clickedItem.name === 'tv' && modalBoolean"
            >
              <iframe
                width="100%"
                height="600"
                src="https://www.youtube.com/embed/Oir8b3cd-r8"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </v-col>
            <v-col
              cols="12"
              class="text-center"
              v-if="clickedItem.name === 'Easel2'"
            >
              <v-img
                v-for="asset in clickedItem.assets"
                :key="asset"
                :src="renderImage(asset)"
                eager
              >
              </v-img>
            </v-col>
            <v-col
              cols="12"
              class="text-center"
              v-if="clickedItem.name === 'Easel1'"
            >
              <viewer
                :images="designImages"
                :options="viewerOptions"
                class="images clearfix"
              >
                <template slot-scope="scope">
                  <v-row justify="center">
                    <v-col
                      v-for="obj in scope.images"
                      :key="obj.src"
                      class="d-flex child-flex"
                      :cols="mobileCol"
                    >
                      <v-hover v-slot:default="{ hover }">
                        <v-card
                          :elevation="hover ? 12 : 2"
                          :class="{ 'on-hover': hover }"
                        >
                          <v-card-title
                            v-html="obj.name"
                            class="justify-center"
                          >
                            {{ obj.name }}
                          </v-card-title>
                          <img :src="obj.src" class="image" />
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </template>
              </viewer>
            </v-col>
            <v-col
              cols="12"
              class="text-center"
              v-if="clickedItem.name === 'Easel3'"
            >
              <viewer
                :images="bridgeImages"
                :options="viewerOptions"
                class="images clearfix"
              >
                <template slot-scope="scope">
                  <v-row justify="center">
                    <v-col
                      v-for="obj in scope.images"
                      :key="obj.src"
                      class="d-flex child-flex"
                      :cols="mobileCol"
                    >
                      <v-hover v-slot:default="{ hover }">
                        <v-card
                          :elevation="hover ? 12 : 2"
                          :class="{ 'on-hover': hover }"
                        >
                          <v-card-title
                            v-html="obj.name"
                            class="justify-center"
                          >
                            {{ obj.name }}
                          </v-card-title>
                          <img :src="obj.src" class="image" />
                        </v-card>
                      </v-hover>
                    </v-col>
                  </v-row>
                </template>
              </viewer>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import Slide2 from "../../public/static/Slide 2/Project Design_old.svg";
import svgMixin from "@/mixins/svgMixin.js";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer/src/component.vue";

export default {
  name: "ProjectDesign",
  components: {
    Slide2,
    Viewer
  },
  mixins: [svgMixin(3, ".slide3", "slide3.js")],
  data() {
    return {
      // Raw html here to avoid ugly text wrapping
      designImages: [
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_01.jpg",
          name: "Estes Road <br> to I-475/I-75"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_02.jpg",
          name: "Klopfer Road <br> to I-475/I-75 "
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_03.jpg",
          name: "I-475/I-75 <br> to Pea Ridge Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_04.jpg",
          name: "Pea Ridge Rd <br> to Rumble Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_05.jpg",
          name: "Rumble Road <br> to Bunn Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_06.jpg",
          name: "Bunn Road <br> to SR 18"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_07.jpg",
          name: "SR 18 to <br> Juliette Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_08.jpg",
          name: "Juliette Road <br> to SR 42"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_09.jpg",
          name: "SR 42 to <br> I-75 Weigh Station"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_10.jpg",
          name: "I-75 Weigh Station <br> to I-75 Median Split"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_11.jpg",
          name: "I-75 Median Split <br> to Johnstonville Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_12.jpg",
          name: "Johnstonville Road <br> to Little Towaliga River"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_13.jpg",
          name: "Little Towaliga River <br> to High Falls Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/Concept-PIOH_Sheet_14.jpg",
          name: "High Falls Road <br> to Buck Creek"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_15.jpg",
          name: "Buck Creek <br> to SR 36"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_16.jpg",
          name: "SR 36 <br> to Colwell Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_17.jpg",
          name: "Colwell Road <br> to Cabin Creek"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/Concept-PIOH_Sheet_18_v2.jpg",
          name: "Cabin Creek to <br> Spalding/Butts <br> County Line"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_19.jpg",
          name: "Spalding/Butts County <br> Line to Jenkinsburg <br> Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_20.jpg",
          name: "Jenkinsburg Road <br> to LG Griffin Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_21.jpg",
          name: "LG Griffin Road <br> to Indian Creek <br> Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_22.jpg",
          name: "Indian Creek Road <br> to Bill Gardner <br> Parkway"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_23.jpg",
          name: "Bill Gardner Parkway <br> to Bethlehem Road"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_24.jpg",
          name: "Bethlehem Road <br> to SR 155"
        },
        {
          src:
            "https://cdn.scoutfeedback.com/gdot-workshop/cvl/design/0014203_Concept+Layouts_2021-01-14_Page_25.jpg",
          name: "SR 155 <br> to SR 20"
        }
      ],
      viewerOptions: {
        title: false
      },
      modalBoolean: false,
      clickedItem: "",
      mouseOverIndex: null,
      showImgModal: false
    };
  },
  computed: {
    mobileCol() {
      return this.$vuetify.breakpoint.mobile ? "12" : "3";
    }
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer;
    },
    show() {
      this.$viewer.show();
    },
    openModalAndPassIndex(index) {
      this.mouseOverIndex = index;
      this.showImgModal = true;
    },
    closeModalAndNullIndex() {
      this.mouseOverIndex = null;
      this.showImgModal = false;
    }
  }
};
</script>

<style>
.mouse {
  cursor: pointer;
}

.image {
  height: 150px;
  /* width: 95%; */
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
